import React, { useCallback, useState } from 'react'

import { Settings as SettingsIcon } from 'components/Icons'
import { SegmentGroup } from 'components/Common'
import SettingsModal from './SettingsModal'

export const Settings = ({ isSyncAvailable }) => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleModalOpen = useCallback(() => {
    setIsModalOpen(true)
  }, [])

  return (
    <>
      <SegmentGroup
        icon={<SettingsIcon width={30} height={30} />}
        title='Settings'
        description='Manage your communication preferences and health subscriptions'
        triggerText={'View ›'}
        onClickTrigger={handleModalOpen}
      />
      {isModalOpen && (
        <SettingsModal
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          isSyncAvailable={isSyncAvailable}
        />
      )}
    </>
  )
}
